import { ortto_communication } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

const PATH = '/ortto/v1/communications';

/**
 * Mutes a customer's transactional communication in one market: the backend
 * fires the Ortto activity `act:cm:stop-current-transactional-communication`
 * and stores the record, with `CreatedAt` and `CreatedBy` (MV-3396).
 */
export const stopTransactionalCommunication =
  ({ url: { service: baseURL }, token }: IAPI) =>
  async ({ customerID, country }: { customerID: string; country: string }) =>
    send<
      { CustomerID: string; Country: string; Type: string },
      ortto_communication.OrttoCommunication | undefined
    >({
      baseURL,
      token,
      path: PATH,
      method: 'POST',
      body: {
        CustomerID: customerID,
        Country: country,
        Type: ortto_communication.STOP_TRANSACTION_COMMUNICATION,
      },
    });

/** Every communication record the backend holds for a customer. */
export const findOrttoCommunications =
  ({ url: { service: baseURL }, token }: IAPI) =>
  async ({ customerID }: { customerID: string | undefined }) =>
    send<void, ortto_communication.OrttoCommunication[] | undefined>({
      baseURL,
      token,
      path: PATH,
      method: 'GET',
      searchParams: { customerID },
    });
